import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import ImmovoxLogo from "@/components/ImmovoxLogo";
import { loginUrl, signupUrl } from "@/lib/productApp";
import { Analytics } from "@/lib/analytics";

const navLinks = [
  { href: "/fonctionnalites", label: "Fonctionnalités" },
  { href: "/cas-dusage", label: "Cas d'usage" },
  { href: "/tarifs", label: "Tarifs" },
  { href: "/blog", label: "Ressources" },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-border/80 bg-background/95 shadow-[0_1px_0_hsl(var(--foreground)/.05)] backdrop-blur-xl">
      <div className="mx-auto max-w-[1440px] px-5 md:px-8 lg:px-12">
        <div className="flex h-[72px] items-center">
          <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="Immovox — accueil">
            <ImmovoxLogo size={31} className="text-primary" />
            <span className="text-[22px] font-semibold tracking-[-0.04em]">Immovox</span>
          </Link>

          <nav className="ml-14 hidden items-center gap-9 lg:flex">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href} className="text-sm font-medium text-foreground/82 transition-colors hover:text-foreground">
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="ml-auto hidden items-center gap-5 lg:flex">
            <a href={loginUrl()} className="text-sm font-medium text-foreground/82 transition-colors hover:text-foreground">Connexion</a>
            <a
              href={signupUrl()}
              onClick={() => Analytics.ctaClicked("demarrer_essai", "header")}
              className="inline-flex h-11 items-center gap-2 rounded-md bg-foreground px-5 text-sm font-semibold text-background transition-colors hover:bg-primary"
            >
              Tester Immovox <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <button
            className="ml-auto inline-flex h-10 w-10 items-center justify-center lg:hidden"
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="border-t border-border bg-background lg:hidden">
          <nav className="px-5 py-5">
            <div className="flex flex-col">
              {navLinks.map((link) => (
                <Link key={link.href} to={link.href} onClick={() => setIsMenuOpen(false)} className="border-b border-border py-4 text-base font-medium">
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-3 pt-5">
              <a href={loginUrl()} className="inline-flex h-11 items-center justify-center rounded-md border border-border text-sm font-medium">Connexion</a>
              <a href={signupUrl()} onClick={() => Analytics.ctaClicked("demarrer_essai", "header_mobile")} className="inline-flex h-11 items-center justify-center rounded-md bg-foreground text-sm font-semibold text-background">Tester Immovox</a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
export default Header;